module.exports = __webpack_public_path__ + "img/1.99bfb429.jpg";